var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleArrow = function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 30"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 14,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.056 20.431a.463.463 0 0 1-.656 0 .466.466 0 0 1-.01-.649l.01-.009 4.758-4.78-4.75-4.766a.466.466 0 0 1-.007-.65l.008-.008a.463.463 0 0 1 .647-.008l.01.008 5.076 5.095a.466.466 0 0 1 .008.65l-.008.008z",
    clipRule: "evenodd"
  })));
};
export default SvgCircleArrow;